import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatLegacySelect } from '@angular/material/legacy-select';
import { MatTableDataSource } from '@angular/material/table';
import { LocalStorageManager } from '@cutting/main/shared/helper/local-storage-manager.helper';
import {
  BazisMaterialHelper,
  CuttingMaterial,
  CuttingMaterialBaseDialogComponent,
  CuttingMaterialBaseDialogData,
  CuttingPanel,
  LegacyDialogsService,
  FaceBand,
} from 'cloud-shared-lib';
import * as _ from 'lodash';
import { lastValueFrom } from 'rxjs';

interface SwapingFaceBandingMaterial {
  oldMaterial: CuttingMaterial;
  newMaterial: CuttingMaterial;
}

export interface FaceBandingReplacementData {
  panels: CuttingPanel[];
}

@Component({
  selector: 'cloud-face-banding-replacement-custom-dialog',
  templateUrl: './face-banding-replacement-custom-dialog.component.html',
})
export class FaceBandingReplacementCustomDialogComponent {
  otherMaterial: CuttingMaterial[] = [];
  newFaceBanding: FaceBand[] = [];
  panel: CuttingPanel[] = [];

  dataSource: MatTableDataSource<SwapingFaceBandingMaterial> = new MatTableDataSource();
  displayedColumns = ['oldFaceBanding', 'newFaceBanding'];

  set panels(val: CuttingPanel[]) {
    this.panel = _.cloneDeep(val);

    const faceBanding: SwapingFaceBandingMaterial[] = this.panel
      .reduce((accum: CuttingMaterial[], item) => {
        item.panelOutline.faceBanding.forEach(item => {
          accum.push(item.material);
        });
        return accum;
      }, [])
      .filter((item, index, arr) => arr.findIndex(d => item && BazisMaterialHelper.compareMaterials(d, item)) === index)
      .map(f => ({ oldMaterial: f, newMaterial: f } as SwapingFaceBandingMaterial));

    this.dataSource.data = faceBanding;
  }

  constructor(
    public dialogService: LegacyDialogsService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<FaceBandingReplacementCustomDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: FaceBandingReplacementCustomDialogComponent
  ) {
    this.panels = data.panels;
  }

  async openMaterialBaseDialog(): Promise<CuttingMaterial[] | undefined> {
    const material = await lastValueFrom(
      this.dialogService.component<CuttingMaterialBaseDialogData, CuttingMaterial[]>(
        CuttingMaterialBaseDialogComponent,
        { multiple: false, materialsToExclude: [] },
        1000
      )
    ).catch(() => {
      return undefined;
    });

    return material;
  }

  async setFaceBandFromMatBase(newFaceBanding: CuttingMaterial, select: MatLegacySelect): Promise<void> {
    const newFaceBandingFromBM = await this.openMaterialBaseDialog();
    if (newFaceBandingFromBM.length > 0) {
      const nbindex = this.dataSource.data.findIndex(b => b.newMaterial && _.isEqual(b.newMaterial, newFaceBanding));

      this.otherMaterial.push(newFaceBandingFromBM[0]);
      this.dataSource.data[nbindex].newMaterial = newFaceBandingFromBM[0];
      select.valueChange.emit(newFaceBandingFromBM[0]);
    }
  }

  saveAndClose(): void {
    this.panel.forEach(panel => {
      panel.panelOutline.faceBanding.forEach(faceBand => {
        const swappingFaceBand = this.dataSource.data.find(
          sb => sb.oldMaterial && _.isEqual(sb.oldMaterial, faceBand.material)
        );
        if (swappingFaceBand.newMaterial) {
          faceBand.material = swappingFaceBand.newMaterial;
        }
      });
    });
    this.dialogRef.close(this.panel);
  }
}
